 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"change-password":"change-password","checkout-index~home~payment-methods~period-register~periods-index~product-register~products-index~pr~d7ea2ba1":"checkout-index~home~payment-methods~period-register~periods-index~product-register~products-index~pr~d7ea2ba1","checkout-index~reports-checkout~reports-checkout-details":"checkout-index~reports-checkout~reports-checkout-details","checkout-index~reports-checkout-details":"checkout-index~reports-checkout-details","checkout-index":"checkout-index","reports-checkout-details":"reports-checkout-details","home~period-register~product-register~toy-register~user-register":"home~period-register~product-register~toy-register~user-register","home~period-register":"home~period-register","home":"home","period-register":"period-register","product-register~toy-register":"product-register~toy-register","product-register":"product-register","user-register":"user-register","payment-methods~products-payment~reports-checkout~reports-rents~reports-rents-per-toy~reports-rents-per-user":"payment-methods~products-payment~reports-checkout~reports-rents~reports-rents-per-toy~reports-rents-per-user","reports-checkout":"reports-checkout","payment-methods":"payment-methods","periods-index~reports-rents":"periods-index~reports-rents","reports-rents":"reports-rents","products-payment":"products-payment","reports-rents-per-toy":"reports-rents-per-toy","reports-rents-per-user":"reports-rents-per-user","periods-index":"periods-index","products-index":"products-index","store-register":"store-register","toys-index":"toys-index","users-index":"users-index","toy-register":"toy-register","login":"login","not-found":"not-found","register":"register","reports-index":"reports-index","reset-password":"reset-password","stores-index":"stores-index"}[chunkId]||chunkId) + "." + {"change-password":"ae0a2d16","checkout-index~home~payment-methods~period-register~periods-index~product-register~products-index~pr~d7ea2ba1":"50c66e2e","checkout-index~reports-checkout~reports-checkout-details":"ac428b6a","checkout-index~reports-checkout-details":"24f72fea","checkout-index":"70ea2bc5","reports-checkout-details":"9a85d1c2","home~period-register~product-register~toy-register~user-register":"4eb163ae","home~period-register":"0fdd2794","home":"c0ef19c6","period-register":"d8500ede","product-register~toy-register":"1963d6bf","product-register":"b72a7f12","user-register":"eb544aeb","payment-methods~products-payment~reports-checkout~reports-rents~reports-rents-per-toy~reports-rents-per-user":"80b65378","reports-checkout":"ea70caa0","payment-methods":"69e00f2f","periods-index~reports-rents":"1ad3a488","reports-rents":"3f60cb5f","products-payment":"edeb50f4","reports-rents-per-toy":"9c370f2d","reports-rents-per-user":"f3497a84","periods-index":"6afff49f","products-index":"6bb9dd37","store-register":"0651f2b2","toys-index":"89c4063a","users-index":"2c6b34aa","toy-register":"92652a84","login":"bd0c0b16","not-found":"52ac4e70","register":"af9ebfce","reports-index":"24e6ef3c","reset-password":"5bf788d0","stores-index":"369f6732"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"change-password":1,"checkout-index~home~payment-methods~period-register~periods-index~product-register~products-index~pr~d7ea2ba1":1,"checkout-index":1,"home~period-register~product-register~toy-register~user-register":1,"home":1,"product-register~toy-register":1,"reports-rents":1,"users-index":1,"toy-register":1,"not-found":1,"register":1,"reports-index":1,"stores-index":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"change-password":"change-password","checkout-index~home~payment-methods~period-register~periods-index~product-register~products-index~pr~d7ea2ba1":"checkout-index~home~payment-methods~period-register~periods-index~product-register~products-index~pr~d7ea2ba1","checkout-index~reports-checkout~reports-checkout-details":"checkout-index~reports-checkout~reports-checkout-details","checkout-index~reports-checkout-details":"checkout-index~reports-checkout-details","checkout-index":"checkout-index","reports-checkout-details":"reports-checkout-details","home~period-register~product-register~toy-register~user-register":"home~period-register~product-register~toy-register~user-register","home~period-register":"home~period-register","home":"home","period-register":"period-register","product-register~toy-register":"product-register~toy-register","product-register":"product-register","user-register":"user-register","payment-methods~products-payment~reports-checkout~reports-rents~reports-rents-per-toy~reports-rents-per-user":"payment-methods~products-payment~reports-checkout~reports-rents~reports-rents-per-toy~reports-rents-per-user","reports-checkout":"reports-checkout","payment-methods":"payment-methods","periods-index~reports-rents":"periods-index~reports-rents","reports-rents":"reports-rents","products-payment":"products-payment","reports-rents-per-toy":"reports-rents-per-toy","reports-rents-per-user":"reports-rents-per-user","periods-index":"periods-index","products-index":"products-index","store-register":"store-register","toys-index":"toys-index","users-index":"users-index","toy-register":"toy-register","login":"login","not-found":"not-found","register":"register","reports-index":"reports-index","reset-password":"reset-password","stores-index":"stores-index"}[chunkId]||chunkId) + "." + {"change-password":"1b866707","checkout-index~home~payment-methods~period-register~periods-index~product-register~products-index~pr~d7ea2ba1":"1b866707","checkout-index~reports-checkout~reports-checkout-details":"31d6cfe0","checkout-index~reports-checkout-details":"31d6cfe0","checkout-index":"08b4354a","reports-checkout-details":"31d6cfe0","home~period-register~product-register~toy-register~user-register":"d0f24381","home~period-register":"31d6cfe0","home":"ad993d8e","period-register":"31d6cfe0","product-register~toy-register":"2f409942","product-register":"31d6cfe0","user-register":"31d6cfe0","payment-methods~products-payment~reports-checkout~reports-rents~reports-rents-per-toy~reports-rents-per-user":"31d6cfe0","reports-checkout":"31d6cfe0","payment-methods":"31d6cfe0","periods-index~reports-rents":"31d6cfe0","reports-rents":"566585d8","products-payment":"31d6cfe0","reports-rents-per-toy":"31d6cfe0","reports-rents-per-user":"31d6cfe0","periods-index":"31d6cfe0","products-index":"31d6cfe0","store-register":"31d6cfe0","toys-index":"31d6cfe0","users-index":"82394c24","toy-register":"1b866707","login":"31d6cfe0","not-found":"1b866707","register":"1b866707","reports-index":"1b866707","reset-password":"31d6cfe0","stores-index":"1b866707"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
